import { WITH_APP_PAGE_BODY_SIZES_CLASS_NAME } from "Common/componentUtils/constants";
import Button from "Components/button";
import ProgressOverlay from "Components/progressOverlay";
import Scrollbars from "Components/scrollbars";
import classNames from "classnames";
import cloneDeep from "lodash/cloneDeep";
import map from "lodash/map";
import React, { useCallback, useEffect, useState } from "react";
import ConnectionBlock from "./connectionBlock";
import locale from "./connections.locale";
import SettingBlock from "./settingBlock";
const SIZES = {
    FORM_WIDTH_MAX: 1100
};
const formStyle = {
    maxWidth: SIZES.FORM_WIDTH_MAX
};
export default function Connections(props) {
    const [draftConnections, setDraftConnections] = useState({});
    const [draftSettings, setDraftSettings] = useState({});
    const [hasChanges, setHasChanges] = useState(false);
    useEffect(() => {
        props.onInitialized && props.onInitialized();
    }, []);
    useEffect(() => {
        setDraftConnections(cloneDeep(props.listConnections || {}));
        setDraftSettings(cloneDeep(props.listSettings || {}));
        setHasChanges(false);
    }, [props.listConnections, props.listSettings]);
    const handleCancel = useCallback(() => {
        setDraftConnections(cloneDeep(props.listConnections || {}));
        setDraftSettings(cloneDeep(props.listSettings || {}));
        setHasChanges(false);
    }, [props.listConnections, props.listSettings]);
    const handleSave = useCallback(() => {
        props.onSave && props.onSave(draftConnections, draftSettings);
    }, [draftConnections, draftSettings, props.onSave]);
    const handleConnectionChanged = useCallback((type, fieldName, value) => {
        setDraftConnections(prev => ({
            ...prev,
            [type]: {
                ...(prev[type] || {}),
                [fieldName]: value,
                Changed: true,
                Type: type
            }
        }));
        setHasChanges(true);
    }, []);
    const handleSettingChanged = useCallback((type, diff) => {
        setDraftSettings(prev => ({
            ...prev,
            [type]: {
                ...(prev[type] || {}),
                ...diff,
                Type: type,
                Changed: true
            }
        }));
        setHasChanges(true);
    }, [draftSettings]);
    return (React.createElement("div", { className: classNames("stretched-to-fit", props.className) },
        React.createElement(ProgressOverlay, { show: props.inProgress, className: classNames("panel-body-padding", WITH_APP_PAGE_BODY_SIZES_CLASS_NAME) },
            React.createElement("div", { className: "d-flex-column with-gap-20" },
                React.createElement("h2", { className: "font-bold" }, locale.CONNECTIONS),
                React.createElement(Scrollbars, { extraRightSpace: true },
                    React.createElement("div", { className: "flex-single-column with-grid-spaces m-auto", style: formStyle },
                        props.typesConnection &&
                            map(props.typesConnection, (typeName, type) => {
                                const connection = draftConnections && draftConnections[parseInt(type)];
                                return (React.createElement(ConnectionBlock, { key: type, type: parseInt(type), title: typeName, connection: connection, onConnectionChanged: props.canEdit ? handleConnectionChanged : undefined, onTest: props.onTest, onReloadOntology: props.canEdit ? props.onReloadOntology : undefined }));
                            }),
                        props.typesSetting && React.createElement("h5", { className: "font-bold" }, locale.SETTINGS),
                        props.typesSetting &&
                            map(props.typesSetting, (typeName, type) => {
                                const setting = draftSettings && draftSettings[type];
                                return (React.createElement(SettingBlock, { key: type, type: type, setting: setting, title: typeName, onSettingChanged: props.canEdit ? handleSettingChanged : undefined }));
                            }),
                        props.canEdit && (React.createElement("div", { className: "d-flex with-gap-8 mt-lg" },
                            React.createElement(Button, { text: locale.SAVE, className: "btn-primary ml-1", disabled: !hasChanges, onClick: handleSave, height: 36 }),
                            React.createElement(Button, { text: locale.CANCEL, onClick: handleCancel, disabled: !hasChanges, height: 36 })))))))));
}
